<template>
    <div>
        <div class="text-center pt-4 pb-4" v-if="predicate">
            <b-spinner class="align-middle" style="width: 3rem; height: 3rem;"></b-spinner>
        </div>
        <div v-cloak v-else>
            <slot></slot>
        </div>
    </div>
</template>

<script>

    /**
     * @description Displays a loading container if the prediate is satisifed, otherwise shows the slow content
     */
    export default {
        props: {
            /* * The predicate that dictates whether the loader should be shown or the slot content should be shown */
            predicate: {
                type: Boolean,
                required: true
            }
        }
    }
</script>
